// extracted by mini-css-extract-plugin
module.exports = {"registered":"Register_registered_Y4Qx3"};